import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0F2A1D] py-16 px-4 border-t border-white/5" data-id="element-139">
      <div className="max-w-4xl mx-auto text-center" data-id="element-140">
        <div className="text-white font-montserrat text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]" data-id="element-141">
          <span className="text-4xl" data-id="element-142">🧬</span> BIOLOGIA PRONTA™
        </div>

        <p className="text-white/80 text-sm tracking-wider mb-2 uppercase font-bold" data-id="element-143">
          EduLabs Italia
        </p>

        <p className="text-white/90 text-lg leading-relaxed mb-10 max-w-xl mx-auto font-medium" data-id="element-144">
          Strumenti moderni per docenti di scienze.
        </p>

        <div className="flex items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-145">
          <span className="flex items-center gap-2" data-id="element-146">
            <span data-id="element-147">📧</span> supporto.biologiapronta@gmail.com
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-148" />

        <p className="text-white/50 text-xs tracking-wider" data-id="element-149">
          © BIOLOGIA PRONTA 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}